import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { LinkedinIcon, MailIcon, FileTextIcon, UsersIcon } from 'lucide-react';
import { useI18n } from '../lib/i18n';
export function Contact() {
  const {
    t
  } = useI18n();
  const [form, setForm] = useState({
    name: '',
    email: '',
    org: '',
    reason: 'colab',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setTimeout(() => {
      toast.success(t('contact.success'));
      setForm({
        name: '',
        email: '',
        org: '',
        reason: 'colab',
        message: ''
      });
      setSubmitting(false);
    }, 600);
  };
  const inputClass = 'w-full px-4 py-3 bg-white/[0.03] border border-white/10 rounded-lg text-white text-sm placeholder-white/30 focus:outline-none focus:border-violet-500/50 transition';
  const links = [{
    icon: LinkedinIcon,
    label: 'LinkedIn',
    href: '#'
  }, {
    icon: MailIcon,
    label: 'contact@clvn-lrr.com',
    href: 'mailto:contact@clvn-lrr.com'
  }, {
    icon: FileTextIcon,
    label: 'Papers',
    href: '#papers'
  }, {
    icon: UsersIcon,
    label: 'Collaborations',
    href: '#'
  }];
  return <section className="w-full bg-[#05060A] py-32 px-6 md:px-12 border-t border-white/5" data-id="element-73">
      <div className="max-w-6xl mx-auto" data-id="element-74">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-light text-white mb-16 tracking-tight" data-id="element-75">
          {t('contact.title')}
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-76">
          <form onSubmit={handleSubmit} className="lg:col-span-3 space-y-5" data-id="element-77">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-78">
              <div data-id="element-79">
                <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-80">
                  {t('contact.name')}
                </label>
                <input type="text" required value={form.name} onChange={e => setForm({
                ...form,
                name: e.target.value
              })} className={inputClass} data-id="element-81" />
              </div>
              <div data-id="element-82">
                <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-83">
                  {t('contact.email')}
                </label>
                <input type="email" required value={form.email} onChange={e => setForm({
                ...form,
                email: e.target.value
              })} className={inputClass} data-id="element-84" />
              </div>
            </div>
            <div data-id="element-85">
              <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-86">
                {t('contact.org')}
              </label>
              <input type="text" value={form.org} onChange={e => setForm({
              ...form,
              org: e.target.value
            })} className={inputClass} data-id="element-87" />
            </div>
            <div data-id="element-88">
              <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-89">
                {t('contact.reason')}
              </label>
              <select value={form.reason} onChange={e => setForm({
              ...form,
              reason: e.target.value
            })} className={inputClass} data-id="element-90">
                <option value="colab" data-id="element-91">{t('contact.reasons.colab')}</option>
                <option value="press" data-id="element-92">{t('contact.reasons.press')}</option>
                <option value="research" data-id="element-93">
                  {t('contact.reasons.research')}
                </option>
                <option value="other" data-id="element-94">{t('contact.reasons.other')}</option>
              </select>
            </div>
            <div data-id="element-95">
              <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-96">
                {t('contact.message')}
              </label>
              <textarea rows={5} required value={form.message} onChange={e => setForm({
              ...form,
              message: e.target.value
            })} className={`${inputClass} resize-none`} data-id="element-97" />
            </div>
            <button type="submit" disabled={submitting} className="px-8 py-3 bg-violet-500 hover:bg-violet-400 disabled:opacity-50 text-white text-sm font-medium rounded-lg transition" data-id="element-98">
              {submitting ? '...' : t('contact.send')}
            </button>
          </form>

          <aside className="lg:col-span-2 lg:pl-8 lg:border-l border-white/10" data-id="element-99">
            <h3 className="text-xs uppercase tracking-widest text-violet-400 mb-6" data-id="element-100">
              {t('contact.links')}
            </h3>
            <ul className="space-y-4" data-id="element-101">
              {links.map(link => {
              const Icon = link.icon;
              return <li key={link.label} data-id="element-102">
                    <a href={link.href} className="flex items-center gap-3 text-white/70 hover:text-white transition group" data-id="element-103">
                      <span className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/10 group-hover:border-violet-500/40 transition" data-id="element-104">
                        <Icon className="w-4 h-4" aria-hidden="true" data-id="element-105" />
                      </span>
                      <span className="text-sm" data-id="element-106">{link.label}</span>
                    </a>
                  </li>;
            })}
            </ul>
          </aside>
        </div>
      </div>
    </section>;
}